import React from "react";
import img from "../../../assets/images/pour.png";
import "./index.scss";
import { CertifIcon } from "../../../assets/icons/CertifIcon";
import { GarantieIcon } from "../../../assets/icons/GarantieIcon";
import { TimeIcon } from "../../../assets/icons/TimeIcon";
import { ParamIcon } from "../../../assets/icons/ParamIcon";
export const Pourquoi = () => {
  return (
    <div className="pourquoi">
      <div className="pourquoi-container mt-5 mb-5">
        <div className="pourquoi-header">
          <div className="pourquoi-title">Pourquoi choisir Bento Habitat ?</div>
          <div className="pourquoi-text mt-3">
            Expertise, accompagnement sur mesure et résultats garantis : faites
            confiance à Bento.{" "}
          </div>
        </div>
        <div className="row  gx-0 w-100 align-items-center mt-5 justify-content-between ">
          <div className="col-12 col-md-6 ">
            <div className="row ps-0 justify-content-center g-5 w-100 align-items-stretch ms-0">
              <div className="col-12 col-md-6 d-flex">
                <div className="card-pourquoi flex-fill d-flex flex-column justify-content-center align-items-center">
                  <div className="card-pourquoi-icons">
                    <CertifIcon />
                  </div>
                  <div className="card-pourquoi-title mt-3">
                    Entreprise certifiée RGE Qualibat pour garantir vos aides
                    financières.
                  </div>
                </div>
              </div>

              <div className="col-12 col-md-6 d-flex">
                <div className="card-pourquoi flex-fill d-flex flex-column justify-content-center align-items-center">
                  <div className="card-pourquoi-icons">
                    <GarantieIcon />
                  </div>
                  <div className="card-pourquoi-title mt-3">
                    Garantie décennale, qualité et finitions irréprochables.
                  </div>
                </div>
              </div>

              <div className="col-12 col-md-6 d-flex">
                <div className="card-pourquoi flex-fill d-flex flex-column justify-content-center align-items-center">
                  <div className="card-pourquoi-icons">
                    <TimeIcon />
                  </div>
                  <div className="card-pourquoi-title mt-3">
                    Respect des délais et propreté de chantier.
                  </div>
                </div>
              </div>

              <div className="col-12 col-md-6 d-flex">
                <div className="card-pourquoi flex-fill d-flex flex-column justify-content-center align-items-center">
                  <div className="card-pourquoi-icons">
                    <ParamIcon />
                  </div>
                  <div className="card-pourquoi-title mt-3">
                    Gestion complète des dossiers MaPrimeRénov’, CEE, TVA 5,5 %.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-5  mt-5 mt-md-0">
            <img src={img} alt="img" className="img-fluid d-none d-md-block" />
          </div>
        </div>
      </div>
    </div>
  );
};
